import { Spin } from 'antd';
import { useEffect, useState } from 'react';

import { Page } from '../../../helbest';
import { API } from '../../../request/api';
import styles from './Faq.module.css';
import FaqItem from './FaqItem/FaqItem';

const Faq = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    API.get
      .faq()
      .then((response) => {
        if (response.code === 200) {
          setData(response.data);
          setLoading(false);
        }
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
  }, []);

  return (
    <Page
      address="/"
      back
      className="page-faq"
      headerFix
      logo
      mobileContainer
      show
      showFooter
      title="سوالات متداول">
      <div className={styles.FaqContainer}>
        {loading ? <Spin className={styles.Spinner} /> : null}
        {!loading ? data.map((dataItem, i) => <FaqItem key={i} {...dataItem} />) : null}
      </div>
    </Page>
  );
};

export default Faq;
